var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5098,
    cy: 20.3672,
    r: 20,
    transform: "rotate(90 20.5098 20.3672)",
    fill: "#25D366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8004 11.6758C11.6619 11.6175 11.509 11.6023 11.3616 11.632C11.2143 11.6616 11.0793 11.7349 10.9741 11.8423C10.8689 11.9496 10.7984 12.0861 10.7717 12.234C10.745 12.3819 10.7634 12.5344 10.8244 12.6718L13.9174 19.6168L22.2594 20.3668L13.9174 21.1168L10.8244 28.0618C10.7634 28.1991 10.745 28.3517 10.7717 28.4996C10.7984 28.6475 10.8689 28.784 10.9741 28.8913C11.0793 28.9987 11.2143 29.0719 11.3616 29.1016C11.509 29.1313 11.6619 29.116 11.8004 29.0578L30.8004 21.0578C30.9363 21.0005 31.0523 20.9043 31.1338 20.7814C31.2153 20.6585 31.2588 20.5143 31.2588 20.3668C31.2588 20.2193 31.2153 20.0751 31.1338 19.9522C31.0523 19.8293 30.9363 19.7331 30.8004 19.6758L11.8004 11.6758Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhatsapp);
export default __webpack_public_path__ + "static/media/sendWhatsapp.7233dcd6aed2e2ffc6c32c20b6fcd8ed.svg";
export { ForwardRef as ReactComponent };